import { HoursCell, TotalHoursCell } from "@/components/hours/cell";
import { TotalNumberCell } from "@/components/number/cell";
import CustomList from "components/list/custom";

export function ByProjectTypeDepartment({ filters }) {
  const columns = [
    {
      accessorKey: "type",
      header: "Project Type",
      cell: ({ getValue }) => <div>{getValue()}</div>,
      footer: () => <div>Total</div>,
    },
    {
      accessorKey: "ongoing",
      header: "Ongoing",
      footer: TotalNumberCell("ongoing"),
    },
    {
      accessorKey: "completed",
      header: "Completed",
      footer: TotalNumberCell("completed"),
    },
    {
      accessorKey: "logged",
      header: "Logged",
      cell: HoursCell,
      footer: TotalHoursCell("logged"),
    },
    {
      accessorKey: "approved",
      header: "Approved",
      cell: HoursCell,
      footer: TotalHoursCell("approved"),
    },
    {
      accessorKey: "unapproved",
      header: "Unapproved",
      cell: HoursCell,
      footer: TotalHoursCell("unapproved"),
    },
    {
      accessorKey: "unreviewed",
      header: "Unreviewed",
      cell: HoursCell,
      footer: TotalHoursCell("unreviewed"),
    },
  ];

  return (
    <div key={JSON.stringify(filters)}>
      <CustomList
        title="By Project type"
        endPoint="custom-ui/get-project-type-timesheet-summary"
        columns={columns}
        filters={filters}
        hidePagination={true}
        storageKey={`reports-dept-overview-by-project-type-${filters?.departmentId}-${filters?.startDate}-${filters?.endDate}`}
      />
    </div>
  );
}
